<div *ngFor="let error of gatherAllErrors()" class="validation-error">
    {{validatorService.getErrorText(error) | async}}
</div>